import type { DealerContextProps } from "@porsche-customer/slfinrtl-context-types"
import { createContext } from "react"

export const DealerContext = createContext<DealerContextProps | undefined>(undefined)
